/// <reference path="../../../../../rest.d.ts"/>
/// <reference path="../../../../../typings/index.d.ts"/>

import * as angular from 'angular';
import { UtilService } from 'app/_services/util.service';

class BalancingGroupTableComponentCtrl implements ng.IController {
    public thereAreBGsWithAssignedNetworkPoints: boolean = false;
    public balancingGroups: BalancingGroupDto[];
    public entriesPerPage: number = 10;

    private paginationId: string;

    constructor(private utilService: UtilService) {}

    public $onInit(): void {
        this.thereAreBGsWithAssignedNetworkPoints =
            this.balancingGroups.filter(
                (b) => b.assignedAccessPoints.length > 0
            ).length > 0;
        // this.paginationNumber = Math.ceil(Math.random()*this.balancingGroups.length);
        this.paginationId =
            'id' + Math.ceil(Math.random() * this.balancingGroups.length);
    }
}

angular.module('app').component('pkpBalancingGroupTable', {
    controller: BalancingGroupTableComponentCtrl,
    template: require('app/_directives/balancing-group-table.component.html'),
    bindings: {
        balancingGroups: '<'
    }
});
